<p class="footer">Copyright © 2014 - {{today | date:'yyyy'}} AC Infotech. All Rights Reserved.</p>
